const getProceccedInviteLinkForSM = (inviteLink: string, source: string) => {
  if (!inviteLink.includes('ref_source')) {
    return inviteLink;
  }
  return inviteLink.replace(/ref_source=[a-z]+/i, `ref_source=${source}`);
};

export default getProceccedInviteLinkForSM;
